import { EyeOffSVG, EyeSVG } from "assets/images";
import React, { useState } from "react";

export default function Password({
  label = "",
  placeholder = "",
  id = "",
  name = "",
  value,
  onChange = () => {},
  // "current-password" / "new-password" lets password managers fill and save
  autoComplete = "off",
  // shown under the field, which turns red
  error = "",
  children,
}) {
  const [hiden, setHiden] = useState(true);
  return (
    <div className="mb-4">
      <label
        htmlFor={id}
        className="mb-2.5 block font-medium text-black dark:text-white"
      >
        {label}
      </label>
      <div className="relative">
        <input
          autoComplete={autoComplete}
          id={id}
          type={hiden ? "password" : "text"}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full py-3 pl-6 pr-12 bg-white border rounded-lg outline-hidden ${error ? "border-red-500" : "border-stroke"} focus:border-brand focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-brand`}
        />

        {/* centred on the field, whatever its height */}
        <span className="absolute right-4 top-1/2 flex -translate-y-1/2">
          {hiden && (
            <button
              type="button"
              onClick={() => {
                setHiden(!hiden);
              }}
            >
              <EyeSVG />
            </button>
          )}
          {!hiden && (
            <button
              type="button"
              onClick={() => {
                setHiden(!hiden);
              }}
            >
              <EyeOffSVG />
            </button>
          )}
        </span>
      </div>
      {error && <p className="mt-1.5 text-sm text-red-600">{error}</p>}
      {children}
    </div>
  );
}
